export default __webpack_public_path__ + "static/media/noaskoptions.ee63d6fd.png";